<template>
    <div>
        <page-header :btn-new="''"
                     pageTitle="PRICE_TABLE.PRICE_TABLE"
                     @newType="setRegisterModal"/>

        <div class="card p-2 pl-3" v-if="hastwoAllotments || steps?.length > 1">
            <div class="row">
                <div class="col-4" v-if="hastwoAllotments">
                    <div class="form-group">
                        <label for="state">{{ t('NAV.ALLOTMENT') }}</label>
                        <Select2 :settings="{ width:'100%', placeholder: 'Selecione um Loteamento' }"
                                 id="allotment"
                                 name="allotment" v-model="currentAllotmentId"
                                 :options="allotments" @select="changeAllotment($event, true)"/>
                    </div>
                </div>
                <div class="col-4" v-if="steps?.length > 1">
                    <div class="form-group">
                        <label for="state">Etapas</label>
                        <Select2 :settings="{ width: '100%', placeholder: 'Selecione uma Etapa' }"
                                 id="step"
                                 name="step" v-model="step_id"
                                 :options="[{id:'selecione', text:'Selecione'}, ...steps]"
                                 @select="changeStep($event)"/>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="isLoadingCards" class="text-center p-4">
            <div class="spinner-border m" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>

        <div class="row gutters" v-else-if="visibleSimulatorCards.length">
            <div v-for="card in visibleSimulatorCards"
                 :key="card.simulator.id"
                 class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                <div class="card">
                    <div class="config-card-content">
                        <div class="config-row">
                            <span class="config-label">Simulador</span>
                            <span class="config-badge badge-simulator">
                                {{ card.simulator.name }}
                            </span>
                        </div>
                        <div class="config-row">
                            <span class="config-label">Descrição</span>
                            <span class="config-badge badge-desc">
                                {{ card.simulator.description || '-' }}
                            </span>
                        </div>
                        <div class="config-row">
                            <span class="config-label">Tabela</span>
                            <span class="config-badge badge-name">
                                {{ card.priceTable?.name || 'Não criada' }}
                            </span>
                        </div>
                        <div class="config-row">
                            <span class="config-label">Status</span>
                            <span v-if="card.priceTable" class="config-badge badge-status-existing">Existe</span>
                            <span v-else class="config-badge badge-status-missing">Não existe</span>
                        </div>
                        <div class="config-row" v-if="card.priceTable">
                            <span class="config-label">Geração</span>
                            <span v-if="card.priceTable.has_generated && card.priceTable.generated_at"
                                  class="config-badge badge-status-generated">
                                {{ formatDateWithMoment(card.priceTable.generated_at) }}
                            </span>
                            <span v-else class="config-badge badge-status-pending">
                                Pendente
                            </span>
                        </div>

                        <div class="pt-2 d-flex gap-8">
                            <button v-if="!card.priceTable && isAdminProfile"
                                    type="button"
                                    class="btn btn-outline-primary btn-sm"
                                    @click="openCreateModalForSimulator(card)">
                                Gerar tabela de preço
                            </button>
                            <button type="button"
                                    v-if="card.priceTable && !card.priceTable.has_generated && isAdminProfile"
                                    class="btn btn-primary btn-sm"
                                    @click="openConfigModal(card)">
                                Gerar Tabela
                            </button>
                            <button type="button"
                                    v-if="card.priceTable"
                                    class="btn btn-outline-secondary btn-sm"
                                    :disabled="!canDownloadPriceTable(card.priceTable)"
                                    :title="canDownloadPriceTable(card.priceTable)
                                        ? 'Baixar arquivo gerado'
                                        : getDownloadTooltip(card.priceTable)"
                                    @click="downloadPriceTable(card.priceTable.id)">
                                Baixar
                            </button>
                            <button type="button"
                                    v-if="card.priceTable && isAdminProfile"
                                    class="btn btn-outline-warning btn-sm"
                                    @click="openDownloadPermissionsModal(card.priceTable)">
                                Permissões de Download
                            </button>
                            <button type="button"
                                    v-if="card.priceTable && isAdminProfile"
                                    class="btn btn-outline-info btn-sm"
                                    @click="openEditPriceTableModal(card.priceTable)">
                                Editar
                            </button>
                            <button type="button"
                                    v-if="card.priceTable && isAdminProfile"
                                    class="btn btn-outline-danger btn-sm"
                                    @click="confirmDeletePriceTable(card.priceTable)">
                                Excluir
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card" v-else-if="!visibleSimulatorCards.length">
            <div class="card-header"></div>
            <div class="card-body pt-0">
                <div class="text-center">
                    <h5>Nenhuma configuração de simulador cadastrada para este loteamento. Cadastre/vincule uma configuração para gerar tabela de preços.</h5>
                </div>
            </div>
        </div>

        <modal-select-allotment v-if="allotments"
                                scope-allotment
                                :showModal="showAllotmentSelect"
                                @showModal="showAllotmentSelect = $event"
                                @allotmentSelected="allotmentSelected"/>

        <modal :titleModal="modalTitle"
               :modal-xl="whichModal === 2">
            <template v-slot:title>{{ t(modalTitle) }}</template>

            <create-price-table-config
                :price-table-id-open="priceTableIdOpen"
                :allotment-id="currentAllotmentId"
                ref="createPriceTableConfig"
                @save="saveConfig"
                v-if="whichModal === 2"/>

            <template v-if="whichModal === 3">
                <div class="modal-body hearder-custom">
                    <div class="row gutters">
                        <div class="col-12">
                            <div class="form-group">
                                <label for="editPriceTableName">Nome</label>
                                <input id="editPriceTableName"
                                       type="text"
                                       class="form-control"
                                       v-model.trim="editPriceTableForm.name">
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <label for="editPriceTableDescription">Descrição</label>
                                <textarea id="editPriceTableDescription"
                                          class="form-control"
                                          v-model.trim="editPriceTableForm.description"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <button type="button"
                                class="btn btn-secondary mr-2"
                                id="closeEditPriceTable"
                                data-dismiss="modal">
                            Fechar
                        </button>
                        <button type="button"
                                class="btn btn-primary"
                                @click="submitEditPriceTable">
                            Salvar
                        </button>
                    </div>
                </div>
            </template>

            <template v-if="whichModal === 4">
                <div class="modal-body hearder-custom">
                    <div class="row gutters">
                        <div class="col-12">
                            <h6 class="mb-3">Permissões de download</h6>
                            <div class="custom-control custom-checkbox mb-2">
                                <input id="allowManagersDownload"
                                       type="checkbox"
                                       class="custom-control-input"
                                       v-model="downloadPermissionsForm.download_allowed_for_managers">
                                <label class="custom-control-label" for="allowManagersDownload">
                                    Permitir download para Gestores
                                </label>
                            </div>
                            <div class="custom-control custom-checkbox mb-2">
                                <input id="allowRealtorsDownload"
                                       type="checkbox"
                                       class="custom-control-input"
                                       v-model="downloadPermissionsForm.download_allowed_for_realtors">
                                <label class="custom-control-label" for="allowRealtorsDownload">
                                    Permitir download para Corretores
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="right mt-3">
                        <button type="button"
                                class="btn btn-secondary mr-2"
                                id="closeDownloadPermissions"
                                data-dismiss="modal">
                            Fechar
                        </button>
                        <button type="button"
                                class="btn btn-primary"
                                @click="submitDownloadPermissions">
                            Salvar
                        </button>
                    </div>
                </div>
            </template>
        </modal>
        <button id="openPriceTableConfigModal"
                type="button"
                class="d-none"
                data-toggle="modal"
                data-target="#customModalTwo"></button>
        <button id="openEditPriceTableModal"
                type="button"
                class="d-none"
                data-toggle="modal"
                data-target="#customModalTwo"></button>
        <button id="openDownloadPermissionsModal"
                type="button"
                class="d-none"
                data-toggle="modal"
                data-target="#customModalTwo"></button>
    </div>
</template>

<script>

import moment from 'moment';
import {mapState} from 'vuex';
import {useI18n} from 'vue-i18n';
import Modal from '@/components/modal';
import {useToast} from 'vue-toastification';
import Select2 from 'vue3-select2-component';
import PriceTable from '@/services/PriceTable';
import UserCompanies from '@/services/UserCompanies';
import SimulatorConfig from '@/services/SimulatorConfig';
import pageHeader from '@/components/layouts/pageHeader.vue';
import modalSelectAllotment from '@/pages/allotment/modalSelectAllotmentComponent.vue';
import CreatePriceTableConfig from '@/pages/priceTable/createPriceTableConfigComponent.vue';

export default {
    name: 'indexPriceTableComponent',

    components: {
        Modal,
        Select2,
        pageHeader,
        modalSelectAllotment,
        CreatePriceTableConfig,
    },

    setup() {
        const toast = useToast();
        const { t } = useI18n();
        return { t, toast };
    },

    computed: {
        ...mapState({
            allotments: 'allotments',
            hastwoAllotments: 'hastwoAllotments',
        }),
        isAdminProfile() {
            return this.currentUserProfile === 'admin';
        },
        visibleSimulatorCards() {
            return (this.simulatorCards ?? []).filter(card => this.hasShowPriceTable(card.priceTable));
        },
    },

    data() {
        return {
            steps: [],
            modalTitle: '',
            priceTables: [],
            simulatorConfigs: [],
            simulatorCards: [],
            whichModal: null,
            currentAllotmentId: null,
            allotmentSelect: {},
            priceTableIdOpen: null,
            showAllotmentSelect: false,
            isLoadingCards: false,
            editPriceTableForm: {
                id: null,
                name: '',
                description: '',
            },
            currentUserProfile: 'realtor',
            downloadPermissionsForm: {
                id: null,
                download_allowed_for_managers: false,
                download_allowed_for_realtors: false,
            },
        };
    },

    mounted() {
        this.currentUserProfile = this.resolveUserProfile();

        if (sessionStorage.getItem('allotmentIdScope')) {
            this.currentAllotmentId = sessionStorage.getItem('allotmentIdScope');

            this.getPriceTables(this.currentAllotmentId);
        } else if (this.allotments?.length === 1) {
            const allotmentId = this.allotments.find(i => i).id;
            sessionStorage.setItem('allotmentIdScope', allotmentId);
            this.currentAllotmentId = allotmentId;

            this.getPriceTables(this.currentAllotmentId);
        } else if (this.allotments?.length) {
            this.showAllotmentSelect = true;
        }
    },

    methods: {
        resolveUserProfile() {
            if (this.$hasPermission('pricetablecontroller_managerdownloadpermission')) return 'admin';
            else if (this.$hasPermission('pricetablecontroller_ismanageronpricetable')) return 'manager';

            return 'realtor';
        },

        formatDateWithMoment(dateString) {
            return moment(dateString).utc().format('DD/MM/YYYY HH:mm:ss');
        },

        isAdmin() {
            return this.currentUserProfile === 'admin';
        },

        async openConfigModal(simulatorCard) {
            const canOpen = await this.setConfigModal(simulatorCard);
            if (canOpen) {
                document.getElementById('openPriceTableConfigModal')?.click();
            }
        },

        async openCreateModalForSimulator(simulatorCard) {
            if (!this.currentAllotmentId) {
                this.toast.info('Selecione um loteamento para continuar.');
                return;
            }

            await this.openConfigModal({
                ...simulatorCard,
                price_table_id: null,
                priceTable: null,
            });
        },

        hasShowPriceTable(priceTable) {
            if (this.isAdmin()) return true;

            if (priceTable?.download_blocked) {
                return false;
            }

            if (this.currentUserProfile === 'manager') {
                return Boolean(priceTable?.download_allowed_for_managers);
            }

            return Boolean(priceTable?.download_allowed_for_realtors);
        },

        canDownloadPriceTable(priceTable) {
            if (!priceTable || !priceTable.has_generated || !priceTable.excel_file_path) return false;
            if (this.isAdmin()) return true;
            if (this.currentUserProfile === 'manager') {
                return Boolean(priceTable.download_allowed_for_managers);
            }
            return Boolean(priceTable.download_allowed_for_realtors);
        },

        getDownloadTooltip(priceTable) {
            if (!priceTable?.has_generated || !priceTable?.excel_file_path) {
                return 'Gere a tabela para liberar download';
            }
            if (this.canDownloadPriceTable(priceTable)) {
                return 'Baixar arquivo gerado';
            }
            return 'Você não tem permissão para baixar esta tabela.';
        },

        async downloadPriceTable(priceTableId) {
            try {
                this.$store.commit('changeLoading', true);
                const resp = await PriceTable.getDownloadUrl(priceTableId);
                const signedUrl = resp?.data?.url;

                if (!signedUrl) {
                    this.toast.info('Arquivo não encontrado ou não gerado.');
                    return;
                }

                window.location.href = signedUrl;
            } catch (e) {
                if (e?.response?.status === 403) {
                    this.toast.info('Você não tem permissão para baixar esta tabela.');
                    return;
                }
                if (e?.response?.status === 404) {
                    this.toast.info('Arquivo não encontrado ou não gerado');
                    return;
                }
                this.errorMsg(e);
            } finally {
                this.$store.commit('changeLoading', false);
            }
        },

        openDownloadPermissionsModal(priceTable) {
            this.whichModal = 4;
            this.modalTitle = 'Permissões de Download';
            this.downloadPermissionsForm = {
                id: priceTable?.id ?? null,
                download_allowed_for_managers: Boolean(priceTable?.download_allowed_for_managers),
                download_allowed_for_realtors: Boolean(priceTable?.download_allowed_for_realtors),
            };
            document.getElementById('openDownloadPermissionsModal')?.click();
        },

        async submitDownloadPermissions() {
            if (!this.downloadPermissionsForm?.id) return;

            try {
                this.$store.commit('changeLoading', true);
                await PriceTable.updateDownloadPermissions(this.downloadPermissionsForm.id, {
                    download_allowed_for_managers: this.downloadPermissionsForm.download_allowed_for_managers,
                    download_allowed_for_realtors: this.downloadPermissionsForm.download_allowed_for_realtors,
                });
                this.toast.success('Permissões de download atualizadas com sucesso.');
                document.getElementById('closeDownloadPermissions')?.click();
                await this.getPriceTables(this.currentAllotmentId);
            } catch (e) {
                this.errorMsg(e);
            } finally {
                this.$store.commit('changeLoading', false);
            }
        },

        async getPriceTables(allotmentId) {
            this.$store.commit('changeLoading', true);
            this.isLoadingCards = true;

            try {
                const resp = await PriceTable.getByAllotment(allotmentId);
                const payload = resp?.data ?? {};

                this.priceTables = payload?.price_tables ?? payload?.items ?? [];
                this.simulatorConfigs = payload?.simulator_configs ?? [];
                this.mountSimulatorCards(this.simulatorConfigs);
            } catch (e) {
                this.priceTables = [];
                this.simulatorConfigs = [];
                this.simulatorCards = [];
                this.errorMsg(e);
            } finally {
                this.isLoadingCards = false;
                this.$store.commit('changeLoading', false);
            }
        },

        buildPriceTableMapBySimulator() {
            const map = new Map();
            (this.priceTables ?? []).forEach(table => {
                const simulatorId = Number(table?.simulator_config_id ?? table?.simulator_config?.id ?? table?.simulatorConfig?.id);
                if (!simulatorId) return;

                const current = map.get(simulatorId);
                if (!current || Number(table?.id ?? 0) > Number(current?.id ?? 0)) {
                    map.set(simulatorId, table);
                }
            });

            return map;
        },

        mountSimulatorCards(simulators) {
            const priceTableBySimulator = this.buildPriceTableMapBySimulator();

            this.simulatorCards = (simulators ?? []).map(simulator => {
                const priceTable = priceTableBySimulator.get(Number(simulator.id)) ?? null;
                return {
                    simulator,
                    priceTable,
                    price_table_id: priceTable?.id ?? null,
                };
            });
        },

        saveConfig() {
            this.toast.success('Solicitação de geração enviada com sucesso.');
            this.getPriceTables(this.currentAllotmentId);
        },

        openEditPriceTableModal(priceTable) {
            this.whichModal = 3;
            this.modalTitle = 'Editar Tabela de Preço';
            this.editPriceTableForm = {
                id: priceTable?.id ?? null,
                name: priceTable?.name ?? '',
                description: priceTable?.description ?? '',
            };
            document.getElementById('openEditPriceTableModal')?.click();
        },

        async submitEditPriceTable() {
            if (!this.editPriceTableForm?.id) return;

            try {
                this.$store.commit('changeLoading', true);
                await PriceTable.update({
                    id: this.editPriceTableForm.id,
                    name: this.editPriceTableForm.name,
                    description: this.editPriceTableForm.description,
                });
                this.toast.success('Tabela atualizada com sucesso.');
                document.getElementById('closeEditPriceTable')?.click();
                await this.getPriceTables(this.currentAllotmentId);
            } catch (e) {
                this.errorMsg(e);
            } finally {
                this.$store.commit('changeLoading', false);
            }
        },

        confirmDeletePriceTable(priceTable) {
            this.$swal.fire({
                title: 'Deseja realmente excluir esta tabela de preços?',
                showCancelButton: true,
                showCloseButton: true,
                confirmButtonText: 'Excluir',
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (!result.isConfirmed) return;

                try {
                    this.$store.commit('changeLoading', true);
                    await PriceTable.delete(priceTable.id);
                    this.toast.success('Tabela excluída com sucesso.');
                    await this.getPriceTables(this.currentAllotmentId);
                } catch (e) {
                    this.errorMsg(e);
                } finally {
                    this.$store.commit('changeLoading', false);
                }
            });
        },

        async setConfigModal(simulatorCard = null) {
            const simulatorId = simulatorCard?.simulator?.id ?? null;
            const tableLinkedToSimulator = this.priceTables.find(table =>
                Number(table?.simulator_config_id ?? table?.simulator_config?.id ?? table?.simulatorConfig?.id) === Number(simulatorId),
            );
            const priceTableId = simulatorCard?.price_table_id ?? tableLinkedToSimulator?.id ?? null;
            const simulatorName = simulatorCard?.simulator?.name || simulatorCard?.simulator?.text || null;

            this.priceTableIdOpen = priceTableId ?? null;
            this.whichModal = 2;
            this.modalTitle = 'PRICE_TABLE.GENERATE';

            const configOptions = this.simulatorConfigs ?? [];
            const selectedSimulatorId = simulatorId ?? configOptions?.[0]?.id;
            if (!selectedSimulatorId) return false;

            SimulatorConfig.show(selectedSimulatorId)
                .then(resp => this.$refs.createPriceTableConfig.setConfigTablePrice(
                    resp.data,
                    configOptions,
                    selectedSimulatorId,
                    {
                        priceTableId: this.priceTableIdOpen,
                        defaultName: simulatorName ? `Tabela ${simulatorName}` : null,
                        defaultDescription: simulatorName ? `Tabela criada para ${simulatorName}` : null,
                    },
                ))
                .catch(err => this.errorMsg(err));

            return true;
        },

        async allotmentSelected() {
            await UserCompanies.chanceCustomScope(sessionStorage.getItem('allotmentIdScope')).then(resp => {
                this.$setCustomToken(resp.data.accessToken, resp.data.refreshToken);
                this.currentAllotmentId = sessionStorage.getItem('allotmentIdScope');
                this.allotmentSelect = this.allotments.find(item => item.id === this.currentAllotmentId);

                this.getPriceTables(this.allotmentSelect.id);
            }).catch(err => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            });
        },

        changeAllotment({ id }, clearStep = false) {
            this.$store.commit('changeLoading', true);
            if (clearStep) sessionStorage.removeItem('stepId');
            localStorage.removeItem('allotmentId');
            localStorage.setItem('allotmentId', id);
            this.allotmentSelect = this.allotments.find(item => item.id === id);
            this.currentAllotmentId = id;
            this.getPriceTables(this.allotmentSelect.id);
        },

        setRegisterModal() {
            this.toast.info('Use o botão "Gerar tabela de preço" nos cards de simulador.');
        },
    },
};

</script>

<style scoped>
.config-card-content {
    padding: 0.85rem 0.9rem;
    background: linear-gradient(135deg, #f8fafc 0%, #eef2f7 100%);
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    position: relative;
    transition: transform 120ms ease, box-shadow 120ms ease, border-color 120ms ease;
}

.config-card-actions {
    position: absolute;
    top: 0.55rem;
    right: 0.6rem;
}

.config-action-btn {
    width: 28px;
    height: 28px;
    border-radius: 999px;
    color: #0f172a;
    background: #ffffff;
    border: 1px solid #dbe3ee;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
}

.config-action-btn:hover {
    background: #0e5e4e;
    color: #ffffff;
    border-color: #0e5e4e;
}

.card:hover .config-card-content {
    transform: translateY(-2px);
    box-shadow: 0 10px 18px rgba(15, 23, 42, 0.08);
    border-color: #cbd5e1;
}

.config-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.35rem 0;
    border-bottom: 1px dashed #dbe3ee;
}

.config-label {
    font-size: 0.78rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: #475569;
    min-width: 92px;
}

.config-row:last-child {
    border-bottom: none;
}

.config-badge {
    font-size: 0.88rem;
    font-weight: 600;
    padding: 0.28rem 0.6rem;
    border-radius: 10px;
    border: 1px solid transparent;
    white-space: nowrap;
    color: #0f172a;
    background: #ffffff;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
}

.badge-name {
    background: #eef6ff;
    border-color: #cfe3ff;
}

.badge-simulator {
    background: #ecfbf4;
    border-color: #c6f2dd;
}

.badge-desc {
    background: #fff4e7;
    border-color: #f7d5a4;
}

.badge-status-existing {
    background: #ecfbf4;
    border-color: #c6f2dd;
}

.badge-status-missing {
    background: #fff1f2;
    border-color: #fecdd3;
}

.badge-status-generated {
    background: #eff6ff;
    border-color: #bfdbfe;
}

.badge-status-pending {
    background: #fef9c3;
    border-color: #fde68a;
}

.gap-8 {
    gap: 0.5rem;
}
</style>
